import React from "react";
import { FaGithub } from "react-icons/fa";

const Projects = () => {
  const projects = [
    {
      name: "Deploy Static Website on Microsoft Azure",
      description:
        "This project implements a visitor count for a static website using the Azure Function (serverless API) and Azure CosmosDB. Each visit to the website triggers the Azure Function, which increments the visitor count in Cosmos DB..",
      github:
        "https://github.com/shreeya20desai/Deploy-Static-Website-On-Microsoft-Azure",
    },
    {
      name: "An Automated System for Local GP",
      description:
        "An Automated System for Local GPs, mainly aims in solving the current problems faced by the patients , Doctor and Nurses. With the help of this project, the main goal is to design a user friendly webapp, appointment scheduling for patients, availability setting for Doctor and Nurses, manage prescription, reduced time involved for appointment booking ,and deployment of the application on one of the Cloud provider(Azure/AWS/GCP).",
      github:
        "https://github.com/shreeya20desai/An-Automated-System-For-Local-GPs",
    },
    {
      name: "Create Billing Alarms",
      description:
        "This project involves creating three Azure billing alarms to monitor the subscription cost..",
      github: "https://github.com/shreeya20desai/Create-Billing-Alarms",
    },

    {
      name: "Lift and Shift Migration",
      description:
        "The aim of the project is to execute a cost-efficient Lift-and-shift migration of The Brew's on-premise database to the Azure Cloud.",
      github: "https://github.com/shreeya20desai/Lift-and-Shift-Migration",
    },
  ];

  return (
    <section
      id="projects"
      style={{
        padding: "60px 20px",
        backgroundColor: "#000",
        color: "#fff",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "50px",
          fontSize: "2.5rem",
          fontWeight: "700",
          color: "#edf4f2ff",
        }}
      >
        Projects
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          justifyContent: "center",
          alignItems: "stretch",
          gap: "30px",
          maxWidth: "1000px",
          margin: "0 auto",
        }}
      >
        {projects.map((project, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#111",
              borderRadius: "10px",
              padding: "25px",
              textAlign: "left",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.5)",
              transition: "transform 0.3s, box-shadow 0.3s, background 0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#00b894";
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 6px 20px rgba(0, 184, 148, 0.6)";
              e.currentTarget.style.color = "#000";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#111";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.5)";
              e.currentTarget.style.color = "#fff";
            }}
          >
            <h3
              style={{
                fontSize: "1.4rem",
                marginBottom: "10px",
              }}
            >
              {project.name}
            </h3>
            <p style={{ fontSize: "1rem", marginBottom: "15px" }}>
              {project.description}
            </p>

            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                textDecoration: "none",
                color: "#00b894",
                fontWeight: "bold",
                transition: "color 0.3s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#000")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#00b894")}
            >
              <FaGithub size={18} />
              View on GitHub
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
